









import { Component, Vue } from 'vue-property-decorator';
import LeftNav from '../../components/LeftNav.vue';
import { NavList } from '@/store/pages/report/index.d';

@Component({
  components: {
    LeftNav,
  },
})
export default class Index extends Vue {
  private navList: NavList[] = [{
    name: '配置管理',
    icon: 'bi-icon-setting',
    path: '/index/reportConfig/config',
    hasAuth: false,
  }];
}
